import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { Breadcrumbs, Box, Typography } from '@mui/material'

export interface Props {
  pathnames: string[]
  nameMap: Record<string, string>
  handleClick: (href: string) => void
  color?: string
}

const CustomBreadcrumbs = ({
  nameMap,
  handleClick,
  pathnames,
  color = '#F68B1E',
}: Props) => (
  <Box width="100%" pb="6px" borderBottom="1px solid #E2E2E2">
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      data-testid="breadcrumbs"
    >
      {pathnames.map((value, index) => {
        const last = index === pathnames.length - 1
        const parsedPath = pathnames
          .slice(0, index + 1)
          .map((item) => {
            if (Number(item)) {
              return ':id'
            }
            return item
          })
          .join('/')

        const href = `/${pathnames.slice(0, index + 1).join('/')}`

        const label = nameMap[parsedPath] ?? ''

        return label ? (
          <Box key={href}>
            {last ? (
              <Typography
                data-testid="label"
                sx={{
                  color,
                }}
              >
                {label}
              </Typography>
            ) : (
              <Box
                onClick={() => handleClick(href)}
                data-testid="link"
                sx={{ cursor: 'pointer' }}
              >
                {label}
              </Box>
            )}
          </Box>
        ) : null
      })}
    </Breadcrumbs>
  </Box>
)

export default CustomBreadcrumbs
